import { render, staticRenderFns } from "./EditMarketSms.vue?vue&type=template&id=512b3b26"
import script from "./EditMarketSms.vue?vue&type=script&lang=js"
export * from "./EditMarketSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports